// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ThirdPartyIntegrationController = function ($rootScope, $scope, $location, $routeParams, $http, gettext, ThirdPartyIntegrationSettings, Features) {
    
    const THIRD_PARTY_INTEGRATION = Object.freeze({
        'Atriga': 'Atriga',
        'Avalara': 'Avalara',
        'Epay': 'Epay',
        'AzureActiveDirectory': 'AzureActiveDirectory',
        'OpenIdConnect': 'OpenIdConnect',
        'Ecosio': 'Ecosio',
        'BlEbics': 'BlEbics',
    });
    
    $scope.thirdPartyIntegrationType = THIRD_PARTY_INTEGRATION;

    $scope.features = Features.features;

    $scope.isAvailableByFeature = function (featureName) {
        var value = $scope.features[featureName];
        return !!value;
    }

    if ($routeParams.thirdPartyIntegration) {
        $scope.settings = ThirdPartyIntegrationSettings.get({ thirdPartyIntegration: $routeParams.thirdPartyIntegration });
        $scope.thirdPartyIntegration = $routeParams.thirdPartyIntegration;
    }
    else {
        var integrations = ThirdPartyIntegrationSettings.query({}, function () {
            if (integrations !== null && !$scope.isAvailableByFeature(THIRD_PARTY_INTEGRATION.Atriga)) {
                for (let i = 0; i < integrations.length; i++) {
                    let item = integrations[i];
                    if (item.ThirdPartyIntegration === THIRD_PARTY_INTEGRATION.Atriga) {
                        integrations.splice(i, 1);
                    }
                }
            }
            if (integrations !== null && !$scope.isAvailableByFeature(THIRD_PARTY_INTEGRATION.Epay)) {
                for (let i = 0; i < integrations.length; i++) {
                    let item = integrations[i];
                    if (item.ThirdPartyIntegration === THIRD_PARTY_INTEGRATION.Epay) {
                        integrations.splice(i, 1);
                    }
                }
            }
            if (integrations !== null && !$scope.isAvailableByFeature(THIRD_PARTY_INTEGRATION.AzureActiveDirectory)) {
                for (let i = 0; i < integrations.length; i++) {
                    let item = integrations[i];
                    if (item.ThirdPartyIntegration === THIRD_PARTY_INTEGRATION.AzureActiveDirectory) {
                        integrations.splice(i, 1);
                    }
                }
            }
            if (integrations !== null && !$scope.isAvailableByFeature(THIRD_PARTY_INTEGRATION.OpenIdConnect)) {
                for (let i = 0; i < integrations.length; i++) {
                    let item = integrations[i];
                    if (item.ThirdPartyIntegration === THIRD_PARTY_INTEGRATION.OpenIdConnect) {
                        integrations.splice(i, 1);
                    }
                }
            }
            if (integrations !== null && $scope.features.EInvoicingEcosio !== true) {
                for (let i = 0; i < integrations.length; i++) {
                    let item = integrations[i];
                    if (item.ThirdPartyIntegration === THIRD_PARTY_INTEGRATION.Ecosio) {
                        integrations.splice(i, 1);
                    }
                }
            }
            if (integrations !== null && $scope.features.BlEbics !== true) {
                for (let i = 0; i < integrations.length; i++) {
                    let item = integrations[i];
                    if (item.ThirdPartyIntegration === THIRD_PARTY_INTEGRATION.BlEbics) {
                        integrations.splice(i, 1);
                    }
                }
            }

            $scope.thirdPartyIntegrations = integrations;
        });
        
    }

    $scope.saveList = function () {
        for (var i = 0; i < $scope.thirdPartyIntegrations.length; i++) {
            (function () {
                var item = $scope.thirdPartyIntegrations[i];
                if (typeof item.Active !== 'undefined') {
                    $http({
                        method: "POST",
                        url: baseUrl + "api/v1/thirdPartyIntegrationSettings/" + item.ThirdPartyIntegration + "/status",
                        cache: false,
                        data: JSON.stringify({ Active: item.Active }),
                        Active: item.Active,
                        headers: { "Content-Type": "application/json" }
                    }).
                    then(function (data) {
                        $scope.thirdPartyIntegrations[i].Active = data.Active;
                        $scope.thirdPartyIntegrations[i].saved = true;
                    }, function (data) {
                        $scope.thirdPartyIntegrations[i].Active = data.Active;
                    });
                    $scope.thirdPartyIntegrations[i].saved = true;
                }
            })();
        }
    };

    $scope.camelCaseToWords = function (value) {
        return value.replace(/([A-Z])/g, " $1").trim();
    }

    $scope.ebicsEntryName = function (value) {
        switch(value) {
            case THIRD_PARTY_INTEGRATION.BlEbics:  
                return gettext("House Bank");
            default:
                return "";
        }
    }
};
ThirdPartyIntegrationController.$inject = ["$rootScope", "$scope", '$location', '$routeParams', '$http', 'gettext', 'ThirdPartyIntegrationSettings', 'Features'];
